import {Translation} from "react-i18next";
import React from "react";

export const columns = [
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("tnp.setting.name")}</span>}
            </Translation>
        ),
        dataIndex: "name",
        ellipsis: {
            showTitle: true,
        },
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("tnp.setting.radiusRange")}</span>}
            </Translation>
        ),
        width: "15%",
        dataIndex: "type",
        // align: "right",
        ellipsis: {
            showTitle: true,
        },
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("tnp.setting.checkInLocation")}</span>}
            </Translation>
        ),
        dataIndex: "address",
        ellipsis: {
            showTitle: true,
        },
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("tnp.setting.description")}</span>}
            </Translation>
        ),
        // sorter: true,
        dataIndex: "description",
        ellipsis: {
            showTitle: true,
        },
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("tnp.setting.status")}</span>}
            </Translation>
        ),
        // sorter: true,
        dataIndex: "status",
        width: 120,
    },

    {
        dataIndex: "menu",
        width : '10%'
    },
];